// src/sections/ListSportsSection.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config/config.js";
import { Link, useParams } from "react-router-dom";

import CardSport from "../components/Cards/CardSport/CardSport";
import { getCumulativeSeriesByEvent } from "../services/cumulativeTable.js";

const getSportsGridClassName = (typeDimension) => {
  const normalizedTypeDimension = Number(typeDimension);

  if (normalizedTypeDimension === 3) {
    return "grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-items-stretch";
  }

  if (normalizedTypeDimension === 2) {
    return "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 justify-items-center";
  }

  return "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 justify-items-center";
};

const ListSportsSection = () => {
  const [sports, setSports] = useState([]);
  const [nameEvent, setNameEvent] = useState("Nombre del Evento");
  const [eventBanner, setEventBanner] = useState("");
  const [subTitleSport, setSubTitleSport] = useState("DEPORTES");
  const [typeDimension, setTypeDimension] = useState(1);
  const [cumulativeSeries, setCumulativeSeries] = useState([]);

  const { idevent } = useParams();

  const normalizedTypeDimension = Number(typeDimension);

  useEffect(() => {
    const fetchSports = async () => {
      try {
        const [sportsResponse, eventResponse, cumulativeResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/categories/?idevent=${idevent}`),
          axios.get(`${API_BASE_URL}/championship/?idevent=${idevent}`),
          getCumulativeSeriesByEvent(idevent).catch((error) => {
            console.error("Error loading cumulative series", error);
            return { series: [] };
          }),
        ]);

        setSports(sportsResponse.data);
        setCumulativeSeries(
          Array.isArray(cumulativeResponse?.series) ? cumulativeResponse.series : []
        );

        const eventData = eventResponse.data;

        setNameEvent(eventData?.name ? eventData.name : "Evento");

        setSubTitleSport(
          eventData?.subTitleSports ? eventData.subTitleSports : "DEPORTES"
        );

        setTypeDimension(
          eventData?.typeDimension ? Number(eventData.typeDimension) : 1
        );

        setEventBanner(eventData?.event_banner ? eventData.event_banner : "");
      } catch (error) {
        console.error("Error fetching sports", error);
      }
    };

    if (idevent) {
      fetchSports();
    }
  }, [idevent]);

  return (
    <>
      <div
        className="flex flex-col items-center w-full"
        style={{ marginTop: "75px" }}
      >
        <div className="text-center mb-4 flex flex-col justify-center items-center">
          {eventBanner && (
            <div className="w-full flex justify-center">
              <img
                src={eventBanner}
                alt="Banner"
                className="w-full sm:w-full md:w-9/10 lg:w-9/10 xl:w-9/10 h-auto"
                style={{ objectFit: "cover", width: "92%" }}
              />
            </div>
          )}

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-blue-600 my-2">
            {nameEvent}
          </h2>

          <h3 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 mt-4">
            {subTitleSport}
          </h3>

          {+idevent === 16 && (
            <a
              href="https://storage.googleapis.com/fedup_info/logos/clubs/Bases_Generales_COPA_ENERGIA_Y_PASION_2025_final.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
            >
              Descargar Bases
            </a>
          )}

          {+idevent === 17 && (
            <>
              <div style={{ display: "flex", gap: "10px" }}>
                <a
                  href="https://storage.googleapis.com/la_liga_files/fedup/Bases%20Generales%20COPA%20ENERG%C3%8DA%20Y%20PASI%C3%93N%202026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
                >
                  Bases de competencia
                </a>
                <a
                  href="https://storage.googleapis.com/fedup_info/images/Bases%20de%20desfile%20y%20concurso%20de%20barras%20COPA%20ENERG%C3%8DA%20Y%20PASI%C3%93N%202026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
                >
                  Bases de Desfile y Concursos de Barras
                </a>
              </div>
            </>
          )}


          {+idevent === 80 && (
            <a
              href="https://storage.googleapis.com/fedup_info/images/puntuacion_general.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
            >
              Descargar Puntuación Final
            </a>
          )}

          {(+idevent === 214 ||
            +idevent === 215 ||
            +idevent === 216 ||
            +idevent === 218) && (
              <a
                href={`/torneos/${idevent}/puntaje-general`}
                rel="noopener noreferrer"
                className="mt-4 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
              >
                Ver Puntuación Final
              </a>
            )}

          {cumulativeSeries.length ? (
            <div className="mt-4 flex flex-wrap justify-center gap-2">
              {cumulativeSeries.map((series) => (
                <Link
                  key={series.id}
                  to={`/torneos/${idevent}/tabla-acumulada?series=${series.id}`}
                  className="inline-flex items-center rounded-lg bg-emerald-600 px-5 py-2.5 font-semibold text-white shadow-sm transition-colors hover:bg-emerald-700"
                >
                  {cumulativeSeries.length > 1
                    ? `Ver ${series.title}`
                    : "Ver Tabla Acumulada"}
                </Link>
              ))}
            </div>
          ) : null}
        </div>

        <div
          className={`mt-4 w-full ${normalizedTypeDimension === 3 ? "max-w-7xl" : "max-w-6xl"
            }`}
        >
          <div className={getSportsGridClassName(normalizedTypeDimension)}>
            {sports.map((sportItem, index) => (
              <div
                key={sportItem?.sport?.idsport || sportItem?.idsport || index}
                className={normalizedTypeDimension === 3 ? "w-full" : ""}
              >
                <CardSport
                  sport={sportItem.sport}
                  typeDimension={normalizedTypeDimension}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ListSportsSection;
